import Breadcrumb from "./widget/Breadcrumb";
import ContactInner from "./widget/ContactInner";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import FooterThree from "./widget/FooterThree";
import RootLayout from "./layout";
import SEO from "./SEO";
const Contact = () => {
  return (
    <>
      <SEO
        title="National Public School Kudlu | Best CBSE School in Bengaluru"
        description="National Public School Kudlu offers quality CBSE education with experienced faculty, modern
infrastructure, sports, and holistic development."
        keywords="National Public School Kudlu,School Near Haralur,School Near Hosur Road,School Near HSR Layout,School Near Electronic City,School Near Bommanahalli,School Near Singasandra, NPS Kudlu,CBSE School Kudlu,Best CBSE School in Kudlu, Best CBSE School in Bengaluru, Top School in Kudlu, CBSE School Near Me, CBSE School Bangalore, Schools in Kudlu,
, Admissions Open CBSE School, Best School in Bangalore"
        canonical="https://npskudlu.com/"
      />
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Contact"} />

        {/* ContactInner */}
        <ContactInner />

        {/* FooterOne */}
        <FooterThree />
      </RootLayout>
    </>
  );
};

export default Contact;
